__turbopack_context__.v({
  "OrganizerName": "event-module__Yd4N5W__OrganizerName",
  "aboutEvent": "event-module__Yd4N5W__aboutEvent",
  "aboutEventContent": "event-module__Yd4N5W__aboutEventContent",
  "artistName": "event-module__Yd4N5W__artistName",
  "artistsList": "event-module__Yd4N5W__artistsList",
  "artistsRow": "event-module__Yd4N5W__artistsRow",
  "auto": "event-module__Yd4N5W__auto",
  "bannerBullet": "event-module__Yd4N5W__bannerBullet",
  "bannerBulletActive": "event-module__Yd4N5W__bannerBulletActive",
  "bannerCustomPagination": "event-module__Yd4N5W__bannerCustomPagination",
  "bannerNavBtn": "event-module__Yd4N5W__bannerNavBtn",
  "bannerNavNext": "event-module__Yd4N5W__bannerNavNext",
  "bannerNavPill": "event-module__Yd4N5W__bannerNavPill",
  "bannerNavPrev": "event-module__Yd4N5W__bannerNavPrev",
  "bannerPillBtn": "event-module__Yd4N5W__bannerPillBtn",
  "bannerPillBtnActive": "event-module__Yd4N5W__bannerPillBtnActive",
  "bannerSwiper": "event-module__Yd4N5W__bannerSwiper",
  "bannerWrapper": "event-module__Yd4N5W__bannerWrapper",
  "body": "event-module__Yd4N5W__body",
  "bookingContentRow": "event-module__Yd4N5W__bookingContentRow",
  "bookingFooter": "event-module__Yd4N5W__bookingFooter",
  "bookingInnerRow": "event-module__Yd4N5W__bookingInnerRow",
  "bookingMainRow": "event-module__Yd4N5W__bookingMainRow",
  "bookingSidebarSticky": "event-module__Yd4N5W__bookingSidebarSticky",
  "card": "event-module__Yd4N5W__card",
  "categoryCard": "event-module__Yd4N5W__categoryCard",
  "categoryTitle": "event-module__Yd4N5W__categoryTitle",
  "contentWrap": "event-module__Yd4N5W__contentWrap",
  "cover": "event-module__Yd4N5W__cover",
  "coverSm": "event-module__Yd4N5W__coverSm",
  "datetime": "event-module__Yd4N5W__datetime",
  "description": "event-module__Yd4N5W__description",
  "digitalEntry": "event-module__Yd4N5W__digitalEntry",
  "eventCMSContent": "event-module__Yd4N5W__eventCMSContent",
  "eventDetailPage": "event-module__Yd4N5W__eventDetailPage",
  "eventPricing": "event-module__Yd4N5W__eventPricing",
  "eventStock": "event-module__Yd4N5W__eventStock",
  "eventSubdetail": "event-module__Yd4N5W__eventSubdetail",
  "eventSummary": "event-module__Yd4N5W__eventSummary",
  "eventSummaryBooking": "event-module__Yd4N5W__eventSummaryBooking",
  "eventSummaryFooter": "event-module__Yd4N5W__eventSummaryFooter",
  "eventSummaryFooterNoBottomNav": "event-module__Yd4N5W__eventSummaryFooterNoBottomNav",
  "eventSummaryItem": "event-module__Yd4N5W__eventSummaryItem",
  "eventSummaryMobile": "event-module__Yd4N5W__eventSummaryMobile",
  "eventSummarySticky": "event-module__Yd4N5W__eventSummarySticky",
  "facilitiesList": "event-module__Yd4N5W__facilitiesList",
  "facilityChip": "event-module__Yd4N5W__facilityChip",
  "footer": "event-module__Yd4N5W__footer",
  "fullHeightFlex": "event-module__Yd4N5W__fullHeightFlex",
  "hideAfterLg": "event-module__Yd4N5W__hideAfterLg",
  "imageGallery": "event-module__Yd4N5W__imageGallery",
  "instagramIframe": "event-module__Yd4N5W__instagramIframe",
  "instgramCover": "event-module__Yd4N5W__instgramCover",
  "leftImg": "event-module__Yd4N5W__leftImg",
  "mainRow": "event-module__Yd4N5W__mainRow",
  "mobileOrganizerCard": "event-module__Yd4N5W__mobileOrganizerCard",
  "organizerLabel": "event-module__Yd4N5W__organizerLabel",
  "organizerName": "event-module__Yd4N5W__organizerName",
  "playButtonCircle": "event-module__Yd4N5W__playButtonCircle",
  "price": "event-module__Yd4N5W__price",
  "responsiveHeader": "event-module__Yd4N5W__responsiveHeader",
  "responsiveTitle": "event-module__Yd4N5W__responsiveTitle",
  "rightImg": "event-module__Yd4N5W__rightImg",
  "sectionTitle": "event-module__Yd4N5W__sectionTitle",
  "sectionTitle2": "event-module__Yd4N5W__sectionTitle2",
  "sidebarContent": "event-module__Yd4N5W__sidebarContent",
  "text": "event-module__Yd4N5W__text",
  "title": "event-module__Yd4N5W__title",
  "titleContainer": "event-module__Yd4N5W__titleContainer",
  "titleSm": "event-module__Yd4N5W__titleSm",
  "tncButton": "event-module__Yd4N5W__tncButton",
  "venue": "event-module__Yd4N5W__venue",
  "videoPosterOverlay": "event-module__Yd4N5W__videoPosterOverlay",
  "videoPosterWrapper": "event-module__Yd4N5W__videoPosterWrapper",
  "watchVideoText": "event-module__Yd4N5W__watchVideoText",
});
